export default "__VITE_ASSET__CI0iv8Jv__"